import React, { useState, useRef, useEffect } from 'react';
import './InputBox.css';
<link
  rel="stylesheet"
  href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/5.15.4/css/all.min.css"
/>


// const InputBoxLarge = ({ 
//   label, 
//   defaultValue = '', 
//   onChange, 
//   type = 'text', 
//   validators = [], 
//   name
// }) => {
//   const [value, setValue] = useState(defaultValue);
//   const [errors, setErrors] = useState([]);
//   const dateInputRef = useRef(null);

//   const handleInputChange = (event) => {
//     const newValue = event.target.value;
  
//     // Ensure validators is an array
//     const validatorArray = Array.isArray(validators) 
//       ? validators 
//       : (validators ? [validators] : []);
  
//     // Run validation
//     const newErrors = validatorArray
//       .map((validator) => {
//         // Check if validator is a function
//         if (typeof validator === 'function') {
//           const result = validator(newValue);
//           // Return error message if validation fails
//           return result === true ? null : result;
//         }
//         return null;
//       })
//       .filter((error) => typeof error === 'string');
  
//     setErrors(newErrors);
  
//     // If no errors, update value and call onChange
//     if (newErrors.length === 0) {
//       setValue(newValue);
//       if (onChange) {
//         onChange(event);
//       }
//     }
//   };
  
//   const handleCalendarIconClick = () => {
//     if (dateInputRef.current) {
//       dateInputRef.current.showPicker();
//     }
//   };

//   return (
//     <div className='large-input-box-container'>
//       <input
//         className={`input-box fts-15 common-text ftw-4 ${
//           type === 'date' ? 'input-box-with-icon hide-native-icon' : ''
//         } ${errors.length > 0 ? 'input-error' : ''}`}
//         type={type === 'small-date' ? 'date' : type}
//         value={value}
//         onChange={handleInputChange}
//         placeholder='' // Empty placeholder to remove default format text
//         ref={type === 'small-date' ? dateInputRef : null}
//         name={name}
//       />
//       <label className={`input-date-label input-label fts-15 common-text ftw-4 ${value ? 'has-value' : ''} ${type === 'small-date' ? 'small-date-label' : ''}`}>
//         {label}
//       </label>
//       {type === 'date' && (
//         <div className='calendar-icon' onClick={handleCalendarIconClick}>
//           <svg className='custom-calendar-icon' width="19" height="20" viewBox="0 0 19 20" fill="none" xmlns="http://www.w3.org/2000/svg">
//             <path d="M17.8125 1.87104L13.0583 1.87106V0.625146C13.0583 0.279753 12.7926 0 12.4646 0C12.1365 0 11.8708 0.279753 11.8708 0.625146V1.87075H7.12084V0.625146C7.12084 0.279753 6.85514 0 6.52709 0C6.19905 0 5.93334 0.279753 5.93334 0.625146V1.87075H1.1875C0.531703 1.87075 0 2.43057 0 3.12104V18.7497C0 19.4402 0.531703 20 1.1875 20H17.8125C18.4683 20 19 19.4402 19 18.7497V3.12104C19 2.43086 18.4683 1.87104 17.8125 1.87104ZM17.8125 18.7497H1.1875V3.12104H5.93334V3.75088C5.93334 4.09625 6.19905 4.37603 6.52709 4.37603C6.85514 4.37603 7.12084 4.09625 7.12084 3.75088V3.12136H11.8708V3.75119C11.8708 4.09658 12.1365 4.37634 12.4646 4.37634C12.7926 4.37634 13.0583 4.09658 13.0583 3.75119V3.12136H17.8125V18.7497ZM13.6562 9.99795H14.8438C15.1715 9.99795 15.4375 9.71788 15.4375 9.3728V8.12251C15.4375 7.77743 15.1715 7.49736 14.8438 7.49736H13.6562C13.3285 7.49736 13.0625 7.77743 13.0625 8.12251V9.3728C13.0625 9.71788 13.3285 9.99795 13.6562 9.99795ZM13.6562 14.9988H14.8438C15.1715 14.9988 15.4375 14.7191 15.4375 14.3737V13.1234C15.4375 12.7783 15.1715 12.4982 14.8438 12.4982H13.6562C13.3285 12.4982 13.0625 12.7783 13.0625 13.1234V14.3737C13.0625 14.7194 13.3285 14.9988 13.6562 14.9988ZM10.0938 12.4982H8.90625C8.5785 12.4982 8.3125 12.7783 8.3125 13.1234V14.3737C8.3125 14.7191 8.5785 14.9988 8.90625 14.9988H10.0938C10.4215 14.9988 10.6875 14.7191 10.6875 14.3737V13.1234C10.6875 12.7786 10.4215 12.4982 10.0938 12.4982ZM10.0938 7.49736H8.90625C8.5785 7.49736 8.3125 7.77743 8.3125 8.12251V9.3728C8.3125 9.71788 8.5785 9.99795 8.90625 9.99795H10.0938C10.4215 9.99795 10.6875 9.71788 10.6875 9.3728V8.12251C10.6875 7.77712 10.4215 7.49736 10.0938 7.49736ZM5.34375 7.49736H4.15625C3.8285 7.49736 3.5625 7.77743 3.5625 8.12251V9.3728C3.5625 9.71788 3.8285 9.99795 4.15625 9.99795H5.34375C5.6715 9.99795 5.9375 9.71788 5.9375 9.3728V8.12251C5.9375 7.77712 5.6715 7.49736 5.34375 7.49736ZM5.34375 12.4982H4.15625C3.8285 12.4982 3.5625 12.7783 3.5625 13.1234V14.3737C3.5625 14.7191 3.8285 14.9988 4.15625 14.9988H5.34375C5.6715 14.9988 5.9375 14.7191 5.9375 14.3737V13.1234C5.9375 12.7786 5.6715 12.4982 5.34375 12.4982Z" fill="#424242"/>
//           </svg>
//         </div>
//       )}
//       {errors.length > 0 && (
//         <div className="input-error-message">
//           {errors[0]}
//         </div>
//       )}
//     </div>
//   );
// };

// export default InputBoxLarge;


const InputBoxLarge = ({ 
  label, 
  defaultValue = '', 
  onChange, 
  type = 'text', 
  validators = [], 
  name,
  error,
  border='',
  isRequired = false
}) => {
  const [value, setValue] = useState(defaultValue);
  const [errors, setErrors] = useState([]);
  const dateInputRef = useRef(null);

  useEffect(() =>{
      setValue(defaultValue)
    },[defaultValue])

  // Ensure validators is always an array
  const validatorArray = Array.isArray(validators) 
    ? validators 
    : (validators ? [validators] : []);

  const effectiveValidators = isRequired 
    ? [
        ...(typeof validatorArray === 'function' ? [validatorArray] : validatorArray),
        (val) => (val !== null && val !== undefined && val !== '') || "This field is required"
      ]
    : validatorArray;


  const validateInput = (inputValue) => {
    // Run all validators
    const newErrors = effectiveValidators
      .map((validator) => {
        if (typeof validator === 'function') {
          const result = validator(inputValue);
          // Return error message if validation fails
          return result === true ? null : result;
        }
        return null;
      })
      .filter((error) => typeof error === 'string');

    return newErrors;
  };

  const handleInputChange = (event) => {
    const newValue = event.target.value;
    
    // Validate input
    const newErrors = validateInput(newValue);
    
    // Update state
    setValue(newValue);
    setErrors(newErrors);

    // Call onChange regardless of validation (to allow parent component to track changes)
    if (onChange) {
      onChange(event);
    }
  };
  
  const handleCalendarIconClick = () => {
    if (dateInputRef.current) {
      dateInputRef.current.showPicker();
    }
  };

  const displayErrors = error ? [error] : errors;

  return (
    <div className='large-input-box-container'>
      <input
        className={`input-box fts-15 common-text ftw-4 ${
          type === 'date' ? 'input-box-with-icon hide-native-icon' : ''
        } ${errors.length > 0 ? 'input-error' : ''} ${border}`}
        type={type === 'small-date' ? 'date' : type}
        value={value}
        onChange={handleInputChange}
        placeholder='' // Empty placeholder to remove default format text
        ref={type === 'small-date' ? dateInputRef : null}
        name={name}
        required
      />
      <label className={`input-date-label input-label fts-15 common-text ftw-4 ${value ? 'has-value' : ''} ${type === 'small-date' ? 'small-date-label' : ''}`}>
        {label}
      </label>
      {type === 'date' && (
        <div className='calendar-icon' onClick={handleCalendarIconClick}>
          <svg className='custom-calendar-icon' width="19" height="20" viewBox="0 0 19 20" fill="none" xmlns="http://www.w3.org/2000/svg">
             <path d="M17.8125 1.87104L13.0583 1.87106V0.625146C13.0583 0.279753 12.7926 0 12.4646 0C12.1365 0 11.8708 0.279753 11.8708 0.625146V1.87075H7.12084V0.625146C7.12084 0.279753 6.85514 0 6.52709 0C6.19905 0 5.93334 0.279753 5.93334 0.625146V1.87075H1.1875C0.531703 1.87075 0 2.43057 0 3.12104V18.7497C0 19.4402 0.531703 20 1.1875 20H17.8125C18.4683 20 19 19.4402 19 18.7497V3.12104C19 2.43086 18.4683 1.87104 17.8125 1.87104ZM17.8125 18.7497H1.1875V3.12104H5.93334V3.75088C5.93334 4.09625 6.19905 4.37603 6.52709 4.37603C6.85514 4.37603 7.12084 4.09625 7.12084 3.75088V3.12136H11.8708V3.75119C11.8708 4.09658 12.1365 4.37634 12.4646 4.37634C12.7926 4.37634 13.0583 4.09658 13.0583 3.75119V3.12136H17.8125V18.7497ZM13.6562 9.99795H14.8438C15.1715 9.99795 15.4375 9.71788 15.4375 9.3728V8.12251C15.4375 7.77743 15.1715 7.49736 14.8438 7.49736H13.6562C13.3285 7.49736 13.0625 7.77743 13.0625 8.12251V9.3728C13.0625 9.71788 13.3285 9.99795 13.6562 9.99795ZM13.6562 14.9988H14.8438C15.1715 14.9988 15.4375 14.7191 15.4375 14.3737V13.1234C15.4375 12.7783 15.1715 12.4982 14.8438 12.4982H13.6562C13.3285 12.4982 13.0625 12.7783 13.0625 13.1234V14.3737C13.0625 14.7194 13.3285 14.9988 13.6562 14.9988ZM10.0938 12.4982H8.90625C8.5785 12.4982 8.3125 12.7783 8.3125 13.1234V14.3737C8.3125 14.7191 8.5785 14.9988 8.90625 14.9988H10.0938C10.4215 14.9988 10.6875 14.7191 10.6875 14.3737V13.1234C10.6875 12.7786 10.4215 12.4982 10.0938 12.4982ZM10.0938 7.49736H8.90625C8.5785 7.49736 8.3125 7.77743 8.3125 8.12251V9.3728C8.3125 9.71788 8.5785 9.99795 8.90625 9.99795H10.0938C10.4215 9.99795 10.6875 9.71788 10.6875 9.3728V8.12251C10.6875 7.77712 10.4215 7.49736 10.0938 7.49736ZM5.34375 7.49736H4.15625C3.8285 7.49736 3.5625 7.77743 3.5625 8.12251V9.3728C3.5625 9.71788 3.8285 9.99795 4.15625 9.99795H5.34375C5.6715 9.99795 5.9375 9.71788 5.9375 9.3728V8.12251C5.9375 7.77712 5.6715 7.49736 5.34375 7.49736ZM5.34375 12.4982H4.15625C3.8285 12.4982 3.5625 12.7783 3.5625 13.1234V14.3737C3.5625 14.7191 3.8285 14.9988 4.15625 14.9988H5.34375C5.6715 14.9988 5.9375 14.7191 5.9375 14.3737V13.1234C5.9375 12.7786 5.6715 12.4982 5.34375 12.4982Z" fill="#424242"/>
          </svg>
        </div>
      )}
      {displayErrors.length > 0 && (
        <div className="input-error-message fts-12">
          {displayErrors[0]}
        </div>
      )}
    </div>
  );
};

export default InputBoxLarge;